import { render } from "./app-sidebar.vue?vue&type=template&id=d186edea&scoped=true"
import script from "./app-sidebar.vue?vue&type=script&lang=js"
export * from "./app-sidebar.vue?vue&type=script&lang=js"

import "./app-sidebar.vue?vue&type=style&index=0&id=d186edea&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d186edea"]])

export default __exports__